export default __webpack_public_path__ + "static/media/darknesswithin.d73acd97.png";